import { KpiService } from "../../kpi/kpi.service";
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
} from "@angular/core";
import { Group } from "../../store/students/state";
import { map, find, orderBy, filter } from "lodash";

@Component({
  selector: "set-group-criteria",
  templateUrl: "./set-group-criteria.component.html",
  styleUrls: ["./set-group-criteria.component.scss"],
})
export class SetGroupCriteriaComponent implements OnInit, OnChanges {
  @Input() group: Group;
  @Input() columns;
  @Output() addCriteria = new EventEmitter();
  @ViewChild("filterSelectAndInputs", { static: true }) filterSelectAndInputs;

  selectedFilterItem;
  min;
  max;
  singleVal;
  selectedColumn;

  noFilterObj = { text: "- No Filter -", id: 1 };
  betweenObj = { text: "Between", id: 2 };
  greaterThanObj = { text: "Greater than or equal to", id: 3 };
  lessThanObj = { text: "Less than or equal to", id: 4 };
  equalToObj = { text: "Equal to", id: 5 };
  filterItems = [
    this.betweenObj,
    this.greaterThanObj,
    this.lessThanObj,
    this.equalToObj,
  ];

  constructor(public kpiService: KpiService) {}

  ngOnInit() {}

  ngOnChanges(change) {
    // remove the Group Status column if there
    // add disabled field to any column which is already selected in the group criteria
    // sort alphabetically
    this.columns = orderBy(
      map(
        filter(this.columns, (column: any) => {
          return column.id != -1;
        }),
        (column: any) => {
          return {
            ...column,
            disabled: find(this.group.efficacyCriteria, [
              "student_kpi_id",
              column.id,
            ]),
          };
        }
      ),
      [(column) => column.title.toLowerCase()],
      ["asc"]
    );
  }

  minChange(event) {
    this.min = event;
  }

  maxChange(event) {
    this.max = event;
  }

  singleValChange(event) {
    this.singleVal = event;
  }

  filter(event) {
    this.selectedFilterItem = event;
  }

  resetFields() {
    this.min = null;
    this.max = null;
    this.singleVal = null;
  }

  criteriaSelected() {
    this.selectedFilterItem = { text: "- No Filter -", id: 1 };
    this.resetFields();
  }

  addGroupCriteria() {
    let newCriteria = {
      student_kpi_id: this.selectedColumn.id,
      min_value:
        this.selectedFilterItem.id == "2"
          ? this.min
          : this.selectedFilterItem.id == "3" ||
            this.selectedFilterItem.id == "5"
          ? this.singleVal
          : null, // for between, min_value = this.min, for greater than, min_value = this.singleVal, for equal to, min_value = this.singleVal
      max_value:
        this.selectedFilterItem.id == "2"
          ? this.max
          : this.selectedFilterItem.id == "4" ||
            this.selectedFilterItem.id == "5"
          ? this.singleVal
          : null,
    };
    this.addCriteria.emit(newCriteria);
    this.kpiService
      .trackStudentGroupCriteriaAdded(
        this.group ? this.group.id : null,
        this.selectedColumn.id
      )
      .subscribe(
        (data) => {},
        (error) => {
          console.error(error);
        }
      );
    this.selectedColumn = null;
    this.filterSelectAndInputs.min = null;
    this.filterSelectAndInputs.max = null;
    this.filterSelectAndInputs.singleVal = null;
    this.filterSelectAndInputs.selectedFilterItem = null;
    this.filterSelectAndInputs.activeItem = null;
  }
}
